"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zip = exports.unzip = void 0;
const fflate_1 = require("fflate");
const unzip = (data, opts) => {
    return new Promise((resolve, reject) => {
        (0, fflate_1.unzip)(data, opts ?? {}, (err, data) => {
            if (err) {
                reject(err);
            }
            else {
                resolve(data);
            }
        });
    });
};
exports.unzip = unzip;
const recursiveConvertToU8Inner = (file) => {
    if (typeof file === "string") {
        return (0, fflate_1.strToU8)(file);
    }
    else if (file instanceof ArrayBuffer) {
        return new Uint8Array(file);
    }
    else if (file instanceof Uint8Array) {
        return file;
    }
    else {
        return recursiveStrToU8(file);
    }
};
const recursiveStrToU8 = (data) => {
    return Object.fromEntries(Object.entries(data).map(([path, file]) => {
        const retFile = ((Array.isArray(file))
            ? [
                recursiveConvertToU8Inner(file[0]),
                file[1],
            ]
            : recursiveConvertToU8Inner(file));
        return [path, retFile];
    }));
};
const zip = (data, opts) => {
    return new Promise((resolve, reject) => {
        (0, fflate_1.zip)(recursiveStrToU8(data), opts ?? {}, (err, data) => {
            if (err) {
                reject(err);
            }
            else {
                resolve(data);
            }
        });
    });
};
exports.zip = zip;
//# sourceMappingURL=zip.js.map